import objectKeys from 'lodash/keys';

export default function rehydrate(raw, data) {
  if (!Array.isArray(raw)) {
    objectKeys(raw).forEach(function (key) {
      raw[key] = rehydrate(raw[key], data);
    }, this);
    return raw;
  } else {
    return raw.map(function (datum) {
      if (datum.year) {
        datum.year = data.years.get(datum.year);
      }

      if (datum.exporter) {
        if (isFinite(datum.exporter)) {
          datum.exporter = data.countries.get(datum.exporter);
        } else {
          datum.exporter = data.countryGroups.get(datum.exporter);
        }
      }

      if (datum.importer) {
        if (isFinite(datum.importer)) {
          datum.importer = data.countries.get(datum.importer);
        } else {
          datum.importer = data.countryGroups.get(datum.importer);
        }
      }

      if (datum.category) {
        if (isFinite(datum.category)) {
          datum.category = data.categories.get(datum.category);
        } else {
          datum.category = data.categoryGroups.get(datum.category);
        }
      }

      return datum;
    });
  }
}
